import { IShellDAO } from '../../../dao/IShellDAO';
import { AbstractRepository } from '../../../core/repositories/AbstractRepository';
import { internalLogger } from '../../../interface/v1/clientOsLogger';

export class InitialNavigationStateRepository extends AbstractRepository<unknown> {
  constructor({
    shellDAO,
    enableSanitizer = false
  }: {
    shellDAO: IShellDAO;
    enableSanitizer?: boolean;
  }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellInitialNavigationState',
      enableSanitizer
    });
  }

  saveAll(): void {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'InitialNavigationStateRepository',
      methodName: 'saveAll()',
      message: 'Not supported in InitialNavigationStateRepository.'
    });
    throw new Error('Method not implemented.');
  }

  findAll(): unknown[] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'InitialNavigationStateRepository',
      methodName: 'findAll()',
      message: 'Not supported in InitialNavigationStateRepository.'
    });
    throw new Error('Method not implemented.');
  }

  delete(): boolean {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'InitialNavigationStateRepository',
      methodName: 'delete()',
      message: 'Not supported in InitialNavigationStateRepository.'
    });
    throw new Error('Method not implemented.');
  }
}
